import React, { useCallback, useEffect, useState } from 'react';
import { runDiagnostics } from '../api/modulesApi';
import { errorMessage } from '../api/securityApi';
import ModuleNav from '../components/Modules/ModuleNav';

export default function DiagnosticsPage() {
  const [checks, setChecks] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const run = useCallback(async () => {
    setBusy(true); setError('');
    try { setChecks(await runDiagnostics()); } catch (e) { setError(errorMessage(e)); } finally { setBusy(false); }
  }, []);
  useEffect(() => { run(); }, [run]);
  const count = (s) => (checks || []).filter((c) => c.status === s).length;

  return (
    <div className="shell">
      <header className="page-header"><div><h1>Setup check</h1><p className="muted">Looks at your data flow and configuration and says what to fix.</p></div>
        <div className="actions"><button className="primary" disabled={busy} onClick={run}>{busy ? 'Checking…' : 'Run again'}</button></div></header>
      <ModuleNav />
      {error && <div className="toast error">{error}</div>}
      {checks && <p className="muted">{count('ok')} OK · {count('warn')} to review · {count('fail')} failing</p>}
      <div className="sec-card">
        {(checks || []).map((c, i) => (
          <div className="mod-check" key={i}>
            <span className={`mod-dot ${c.status}`} />
            <div><b>{c.name}</b><div>{c.detail}</div>{c.fix && c.status !== 'ok' && <div className="muted">→ {c.fix}</div>}</div>
          </div>))}
      </div>
    </div>
  );
}
